import { useQuery } from 'react-query'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchAllProducts } from '../query-api'
import { Product } from '../types/product'

interface UseFetchAllProductsProps {
  enabled?: boolean
}

interface UseFetchAllProductsResponse {
  isLoading: boolean
  products: Product[]
}

export const useFetchAllProducts = ({ enabled = true }: UseFetchAllProductsProps = {}): UseFetchAllProductsResponse => {
  const { data, isLoading } = useQuery([QueryKeys.Products, 'all'], fetchAllProducts, {
    enabled,
    staleTime: defaultStaleTime,
  })

  return {
    isLoading,
    products: data ?? [],
  }
}
